import { Box, Typography } from "@mui/material"
import dayjs from "dayjs"
import { useNavigate } from "react-router-dom"
import { InfoBox } from "../../components/DOAAdminComponents/InfoBox"
import { DOAIconComp } from "../../components/DOAIconComp"
import { MainContainer } from "../../components/MainContainerComp"
import { Status } from "../doa-forecast/DoaForecastModels"
import { IDOAShift } from "./AvailabilityAdministrationData"

interface IAvailabilityAdministrationProps {
  shifts: IDOAShift[]
}

export const AvailabilityAdministration: React.FC<IAvailabilityAdministrationProps> = ({
  shifts
}) => {
  const navigate = useNavigate();

  const onShiftClick = (dispatch: string, date: string) =>
    navigate(`/availability-administration-employee/${dispatch}/${dayjs(date, 'DD.MM.YYYY').format('DDMMYYYY')}`)

  return (
    <MainContainer>
      <DOAIconComp />
      <Typography sx={{ mt: 1, mb: 1, textAlign: 'center' }} data-automation="doa-avail-desc-text">
        The Declaration of Availability Administration page allows you to declare an employee
        as available or unavailable for a given dispatch.
      </Typography>
      <Typography
        component={'div'}
        variant='container'
        data-automation="data-container"
      >
        {
          shifts.map(((item, i) => (
            <Box sx={{ mb: 3 }} key={i}>
              <InfoBox
                date={item.dispatchDate}
                dispatch={item.shift}
                dispatchDescription={item.shiftDescription}
                availabilityStatus={item.availabilityStatus as Status}
                dispatchStatus={item.physicalDspatchStatus as Status}
                onClick={onShiftClick}
              />
            </Box>
          )))
        }
      </Typography>
    </MainContainer>
  )
}